import "src/components/reusable/context/AppThemeProvider/global.css";
import "react-toastify/dist/ReactToastify.css";
import type { AppContext, AppProps } from "next/app";
import { AppProviderRoot } from "src/components/reusable/context/AppProviderRoot";
import { bindServerSideTeamSchema } from "src/components/reusable/components/TeamConfigProvider";
import { constants } from "src/shared/constants";
import React from "react";

export default function AppRenderer({ Component, pageProps }: AppProps) {
  return (
    <AppProviderRoot pageProps={pageProps}>
      <Component {...pageProps} />
    </AppProviderRoot>
  );
}
AppRenderer.getInitialProps = async (ctx: AppContext) => {
  const pageProps = await bindServerSideTeamSchema(ctx);

  // Capture the MLB Ballpark SSO headers on every initial server-side render,
  // regardless of route. This makes them available via cookie for any future
  // default route, not just index.tsx.
  const { req, res } = ctx.ctx;
  if (req && res) {
    const { oktaId, email } = constants.mlbBallparkHeaders;
    const readHeader = (name: string) => {
      const raw = req.headers?.[name];
      return Array.isArray(raw) ? raw[0] : raw;
    };

    const cookies: string[] = [];
    const mlbBallparkOktaId = readHeader(oktaId);
    if (mlbBallparkOktaId) {
      cookies.push(`${oktaId}=${mlbBallparkOktaId}; Path=/; HttpOnly; SameSite=Lax`);
    }
    const mlbBallparkEmail = readHeader(email);
    if (mlbBallparkEmail) {
      cookies.push(`${email}=${mlbBallparkEmail}; Path=/; HttpOnly; SameSite=Lax`);
    }

    if (cookies.length) res.setHeader("Set-Cookie", cookies);
  }

  return pageProps;
};
